module.exports = __webpack_public_path__ + "3ef6639a4cce5b903e4031b1b0102675.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/materialdesignicons-webfont.ttf?v=2.0.46
// module id = 598
// module chunks = 0